import { Component, EventEmitter, Output, Input, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from '../tools/header.service';
import { Language } from '../entities/Language';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LogInService } from '../tools/login-service';
import { StorageService } from '../tools/storage.service';
import { Utils } from '../tools/utils';
import { Roles, TchatService, IxellAPIService, Tchat, LacourIdPAuthenticationService } from '../tools/api.service';
import { SITE_VERSION } from '../entities/Constants';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'sideMenu',
    templateUrl: './sideMenu.component.html',
    styleUrls: ['./sideMenu.component.scss']
})
export class SideMenuComponent implements OnInit, OnDestroy {
    @Input() currentlanguage: string;
    @Output() sidenavClose = new EventEmitter();
    selected: any; // @clemence
    private langue: string;
    private logoLangue: string;
    form: UntypedFormGroup;
    activList = false;
    lstLangue: Language[];
    role: Roles;
    Roles = Roles;
    Utils = Utils;
    identity: string = "";
    private roleSub: any;
    private identitySub: any;
    private connectionSub: any;

    urlPortailConnexion: string = environment.oauthRoot;
    urlApi: string = environment.apiRoot;

    displayCGUModal: boolean = false;

    tchatToken: string;
    temp: Tchat = new Tchat;

    version: string;

    constructor(private headerService: HeaderService, private apiService: IxellAPIService, private tchatService: TchatService, private fb: UntypedFormBuilder, private router: Router, private login: LogInService, private storage: StorageService, private oauthService: LacourIdPAuthenticationService) { }
    ngOnInit() {
        this.form = this.fb.group({
            languageSelect: this.currentlanguage
        });
        this.lstLangue = [
            { codeLangue: "de", langue: "Deutsch" },
            { codeLangue: "en", langue: "English" },
            { codeLangue: "es", langue: "Española" },
            { codeLangue: "fr", langue: "Français" },
            { codeLangue: "it", langue: "Italiano" },
            { codeLangue: "nl", langue: "Nederlands" },
            { codeLangue: "ro", langue: "Românesc" },
            { codeLangue: "pt", langue: "Português" },
            { codeLangue: "pl", langue: "Polski" },
            { codeLangue: "tr", langue: "Türk" }
        ];

        //this.headerService.currentLangue.subscribe(langue => this.langue = langue);
        //if (this.storage.get("userIdentity"))
        //  this.identity = this.storage.get("useridentity");
        //else
        //  this.identitySub = this.apiService.getUserInfos().subscribe(data => {
        //    this.storage.set("userIdentity", data.firstname + " " + data.name); this.identity = data.firstname + " " + data.name;
        //  });

        //if (this.form.get['languageSelect'] != null)
        //  this.form.get['languageSelect'].setValue(this.currentlanguage);
        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
        this.headerService.verifyRole();

        this.version = SITE_VERSION;
    }

    ngOnDestroy() {
        if (this.roleSub != null) this.roleSub.unsubscribe();
    }


    public onSidenavClose() {
        this.sidenavClose.emit();
    }

    selectLangue(event: string) {
        this.storage.set("actualLanguage", event)
        this.headerService.changeLangue(event);
        this.onSidenavClose();

    }

    disconnect() {
        Utils.deleteStorageData();
        localStorage.removeItem("cart");
        sessionStorage.removeItem("cartCode");
        this.headerService.changeNbProduct(0);
        this.headerService.changeProducts(null);
        this.headerService.changeLogo(null);
        this.closeTchat();
        this.login.clearLogOut();
        ///*----------------------------------------------------------------------------------------------------*/console.log("storage token / tokenOAuth after clear and before call logoutOAuth");
        ///*----------------------------------------------------------------------------------------------------*/console.log("token");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.storage.get("token"));
        ///*----------------------------------------------------------------------------------------------------*/console.log("tokenOAuth");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.storage.get("tokenOAuth"));
        window.setTimeout(() => {
            window.location.replace(this.urlApi + "/LacourIdPAuthentication/Logout");
        }, 50);
    }

    goHome() {
        Utils.deleteStorageData();
        this.headerService.changeCanBack(false);
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeLogo(null);
        this.onSidenavClose();
    }

    //goContretypage() {
    //  this.headerService.changeCanBack(true);
    //  this.headerService.changeTitle("Contretypage");
    //  this.onSidenavClose();
    //}

    isAdmin() {
        if (this.role & Roles.AdminLacour)
            return true;
        else
            return false;
    }

    openCGU() {
        this.displayCGUModal = true;
        let modal = document.getElementById("ModalCGU");
        modal.style.display = "block";
        this.sidenavClose.emit();
    }

    closeCGU() {
        let modal = document.getElementById("ModalCGU");
        modal.style.display = "none";
    }

    closeTchat() {
        if (sessionStorage.getItem("urlTchat")) {
            this.apiService.getConnectionInfos().subscribe(data => {
                this.temp.login = data.login;
                this.temp.pwd = data.pwd;
                this.temp.token = data.token;
            });

            window.setTimeout(() => {
                this.tchatService.closeConversation(this.temp).subscribe(data => {
                }, error => {
                    console.log(error);
                });
            }, 500);
        }
    }

    //goPortailConnection() {
    //    window.open("https://auth.dev.groupe.lacour", '_blank').focus();
    //    //window.open("https://dev-tmathys.groupe.lacour/IxellApi/IxellApi/RedirectionPortailConnexion", '_blank').focus();
    //}

}
